function Watermark() {
	return (
		<div className="absolute bottom-0 right-0 -z-1">
			<img src={process.env.PUBLIC_URL + "/svgs/watermark.svg"} alt="Process Instruments" />
		</div>
	);
}

export default Watermark;
